import { Platform } from '@/features/pages';
import { Departments } from '@/types';

export namespace managerTypes {
  export type Manager = {
    _id: string;
    account: {
      _id: string;
    };
    pages: { _id: string; platform: Platform; name: string }[];
    username: string;
    password: string;
    department: Departments;
    email?: string;
    /** Required to record a check from the mobile CRM — it is sent to the bot as the check author. */
    telegram?: {
      id: number;
      username?: string;
    };
    config: {
      isUsernamesVisible: boolean;
      isSystemMessagesVisible: boolean;
      isMessagesTranslationEnabled: boolean;
    };
  };

  export type GetManagers = (params: {
    department?: Departments;
  }) => Promise<{ managers: Manager[] }>;
  export type SignUpManager = (data: {
    username: string;
    password: string;
    email?: string;
    department: Departments;
  }) => Promise<void>;
  export type EditManagerConfig = (data: {
    managerId: string;
    config: Manager['config'];
    email?: string;
  }) => Promise<void>;
  export type SetManagerTelegram = (data: {
    managerId: string;
    /** Omit to unlink the telegram account. */
    telegram?: Manager['telegram'];
  }) => Promise<void>;
  export type DeleteManager = (params: { managerId: string }) => Promise<void>;

  export type AddManagerPage = (data: { managerId: string; pageId: string }) => Promise<void>;
  export type RemoveManagerPage = (params: { managerId: string; pageId: string }) => Promise<void>;
  export type ChangeManagerPagesOrder = (params: {
    managerId: string;
    pageIds: string[];
  }) => Promise<void>;

  export type SetManagerPassword = (data: { managerId: string; password: string }) => Promise<void>;

  export type ManagerDevice = {
    model: string;
    os: string;
    osVersion: string;
    appVersion: string;
    updatedAt: number;
    lastSeenAt?: number;
  };

  export type ManagerDeviceRow = {
    _id: string;
    username: string;
    department: Departments;
    device: ManagerDevice;
  };

  export type GetManagerDevices = () => Promise<{
    managers: ManagerDeviceRow[];
    models: { model: string; count: number }[];
  }>;
}
